export const Empty = "00000000-0000-0000-0000-000000000000";

export function isNullOrEmpty(guid: string): boolean {
	return guid == null || guid == "" || guid == Empty;
}

export function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export function isGuid(guid: string) {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(guid);
}

export function newGuid(): string {
	const randNumber = Math.floor(Math.random() * 1000000000000);
	return "00000000-0000-0000-0000-" + randNumber.toString().padStart(12, "0");
}

